require('./externalTransferFundStep4.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
import { withRouter } from 'react-router-dom';
// @ actions
// @ commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('commonsComponents/OKTooltip');
const { OKMessage } = require('commonsComponents/OKMessage');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
// @ components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation'
// @helpers
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    PREFIX_SPANISH_ISIN_CODE,
    CONTENT_TYPE_PDF,
    BROKER_PRODUCT_TYPE_FUNDS
} = require('constants/index');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const { EXTERNAL_TRANSFER_FUNDS, messages: { EXTERNAL_TRANSFER_FUNDS_AND_GDPR } } = require('constants/operationTypes');
const { EXTERNAL_FUNDS_TRANSFER_GDPR_PID } = require('constants/gdprPlacementIds');

class ExternalTransferFundStep4 extends React.Component {
    constructor(props) {
        super(props);
        this.handleReadCheckChange = this.handleReadCheckChange.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
    }

    componentDidMount() {
        const { postValidation, fetchLegalDocuments, history } = this.props;
        postValidation(history);
        const selectedDestinationFund = this.getSelectedDestinationFund();
        fetchLegalDocuments(selectedDestinationFund.get('isin'), null, null, null, null, history);
    }

    getSelectedDestinationFund() {
        const { immExternalTransferFund, immBrokerMyInvestments } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
        const selectedDestinationFund = immExternalTransferFund.getIn([
            'steps',
            2,
            'destinationFund'
        ]);

        return immFunds.find(immFund => immFund.get('id') == selectedDestinationFund);
    }

    buildDisclaimerLabel(destinationFundName) {
        const destFundIsin = this.getSelectedDestinationFund().get('isin');
        const isFundNational = destFundIsin.startsWith(PREFIX_SPANISH_ISIN_CODE);

        const fundamentalDataForInvestorLink = <FormattedText value="fundLegalDocumentDisclaimer-fundamentalDataForInvestor" />
        const marketingReportsLink = <FormattedText value="fundLegalDocumentDisclaimer-marketingReports" />
        const lastPublishedEconomicReportLink = <FormattedText value="fundLegalDocumentDisclaimer-lastPublishedEconomicReport" />
        const fundTransactionCostLinklabel = <FormattedText value="fundLegalDocumentDisclaimer-transactionCost" />

        if (isFundNational) {
            return (
                <FormattedTextWithComponents
                    value="fundLegalDocumentDisclaimer-spanish"
                    className="external-transfer-fund-step4__legal-disclaimer ok-checkbox__label--relative"
                    injectedComponents={[
                        fundamentalDataForInvestorLink,
                        destinationFundName,
                        lastPublishedEconomicReportLink,
                        fundTransactionCostLinklabel
                    ]}
                />
            );
        } else {
            return (
                <FormattedTextWithComponents
                    value="fundLegalDocumentDisclaimer-other"
                    className="external-transfer-fund-step4__legal-disclaimer ok-checkbox__label--relative"
                    injectedComponents={[
                        fundamentalDataForInvestorLink,
                        destinationFundName,
                        lastPublishedEconomicReportLink,
                        marketingReportsLink,
                        fundTransactionCostLinklabel
                    ]}
                />
            );
        }
    }

    handleDisclaimerClick() {
        const destFundIsin = this.getSelectedDestinationFund().get('isin');
        const immFundTransactionCostDocument = this.props.immBrokerFundLegalDocument.getIn(['fundTransactionCostDocument', destFundIsin]);
        const dataBlock = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('base64Data') : '';
        const dataID = immFundTransactionCostDocument ? immFundTransactionCostDocument.get('objectId') : '';
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
        downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
    }

    handleReadCheckChange(ev) {
        this.props.setCheckbox(ev.target.checked);
    }

    render() {
        const { immExternalTransferFund, setDocumentsRead } = this.props;
        const checked = __CONTACT_CENTER__ ? immExternalTransferFund.getIn(['steps', 3, 'legalInfoChecked']) === SELECTED_VALUES.YES : immExternalTransferFund.getIn(['steps', 3, 'readChecked']);
        const checkedIsValid = immExternalTransferFund.getIn(['steps', 3, 'checkedIsValid']);
        const account = immExternalTransferFund.getIn(['steps', 0, 'account']);
        const selectedDestinationFund = this.getSelectedDestinationFund();
        const isin = selectedDestinationFund.get('isin')
        const destinationFundProduct = selectedDestinationFund.get('product');
        const destinationFundContract = selectedDestinationFund.get('numerodecontrato');
        const destinationFundName = selectedDestinationFund.get('name');
        const checkboxLabel = this.buildDisclaimerLabel(destinationFundName);
        const destinationAccount = `${destinationFundProduct}${destinationFundContract}`;
        const showWarning = immExternalTransferFund.getIn(['steps', 3, 'showWarning']);

        const operationParams = {
            originAccount: account,
            destinationAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${destinationAccount}`
        };

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="external-transfer-fund-step4__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            )
        }

        if (__CONTACT_CENTER__ && immExternalTransferFund.getIn(['steps', 3, 'legalInfoChecked']) === SELECTED_VALUES.NO) {
            return null;
        }

        let signaturePattern = null;
        if (checked) {
            signaturePattern = (
                <div className="external-transfer-fund-step4__signature-container">
                    <GDPRSignaturePattern
                        operationType={EXTERNAL_TRANSFER_FUNDS}
                        operationParams={operationParams}
                        multiOTPMessageCode={EXTERNAL_TRANSFER_FUNDS_AND_GDPR}
                        isWealth={true}
                    />
                </div>
            )
        }

        return (
            <div className="external-transfer-fund-step4">
                <FormattedText
                    value="brokerExternalTransferFundStep4-title"
                    className="external-transfer-fund-step4__title"
                />
                <FormattedText
                    value="brokerExternalTransferFundStep4-subtitle"
                    className="external-transfer-fund-step4__subtitle"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText('operatives-externalTransferFunds')}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                <WebappRender>
                    <OKConsents placementId={EXTERNAL_FUNDS_TRANSFER_GDPR_PID} />
                    <div>
                        <BrokerLegalDocumentation
                            className="hire-investment-step2__documentation-box"
                            isin={isin}
                            productDefinition={destinationFundName}
                            productType={BROKER_PRODUCT_TYPE_FUNDS}
                            reportCompleted={() => setDocumentsRead()}
                        />
                    </div>
                    {documentsNotRead}
                    <OKTooltip
                        content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'} />}
                        offset={[-50, -5]}
                        placement={'topLeft'}
                        target={
                            <div className="external-transfer-fund-step4__description">
                                <OKCheckbox
                                    idName="external-transfer-step4-checkbox"
                                    onChange={this.handleReadCheckChange}
                                    errorState={!checkedIsValid}
                                    errorMessage={formatText('brokerHireInvestmentStep2-checkError')}
                                    value={checked}
                                    label={checkboxLabel}
                                />
                            </div>
                        } />
                </WebappRender>
                {signaturePattern}
            </div>
        );
    }
}

ExternalTransferFundStep4.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    setCheckbox: PropTypes.func.isRequired,
    postValidation: PropTypes.func.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ExternalTransferFundStep4);
